import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const affiliateProfileList = (request) => {     
    let ENDPOINT = URL_BASE_API+'user/affiliate-profiles/';
    if(request.data!==undefined){    
        let search   = request.data.search;
        let pageId   = request.data.page;
        let column   = request.data.column;    
        let pageSize = request.data.pageSize; 
        if(column||pageId||search||pageSize){
            ENDPOINT += '?page='+pageId+'&column='+column+'&affiliate_name='+search+'&page_size='+pageSize;
        }   
        let applyFilter=0; 
        if(request.data.filterApplied && Number(request.data.filterApplied) > 0 && request.data.filtersData) {
            applyFilter=1; 
            let filtersData = request.data.filtersData;
            if(filtersData.statusActive && filtersData.statusActive!='') {
                ENDPOINT += '&status='+filtersData.statusActive;
            }

            if(filtersData.includeDate) { 
                ENDPOINT += '&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate;
            } 
            
            if(applyFilter) ENDPOINT += '&filter='+applyFilter; 
        }
    }

    return service.get(ENDPOINT);  
}; 

export const affiliateProfileEdit = (request) => {
    let affiliateId = request.data;
    const ENDPOINT = URL_BASE_API+'user/get-affiliate-profile/'+affiliateId;
    return service.get(ENDPOINT);  
    
}; 

export const affiliateCompanyInfoAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'user/affiliate-profile/';
  
    return service.post(ENDPOINT,request.data);
    
}; 

export const affiliateCompanyInfoUpdate = (request) => {
    let affiliateId = request.data.get('id');
    const ENDPOINT = URL_BASE_API+'user/affiliate-profile/'+affiliateId;
  
    return service.put(ENDPOINT,request.data);  
    
}; 

export const affiliateAddressUpdate = (request) => {
    let affiliateId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/affiliate-address/'+affiliateId;
    delete request.data.profileId;
    return service.put(ENDPOINT,request.data);  
    
}; 

export const affiliatePrimaryContactUpdate = (request) => {
    let affiliateId = request.data.profileId;
    let userType = request.data.userType;
    if(request.data.hasOwnProperty('associate_id')){
        const ENDPOINT = URL_BASE_API+'user/primary-contacts/?user_type='+userType+'&profile_id='+affiliateId;
        delete request.data.profileId; 
        delete request.data.userType; 
        return service.post(ENDPOINT,request.data); 
    }else{
        const ENDPOINT = URL_BASE_API+'user/affiliate-primary/'+affiliateId;
        delete request.data.profileId; 
        return service.put(ENDPOINT,request.data);  
    }
    
    
}; 

export const affiliateSettingsUpdate = (request) => {
    let affiliateId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/affiliate-settings/'+affiliateId;
    delete request.data.profileId;
    let data = request.data
    data["region_time_zone"] = data.time_zone
    delete data.time_zone;
    return service.put(ENDPOINT,data);  
}; 

export const affiliateDelete = (request) => {
    const ENDPOINT = URL_BASE_API+'user/affiliate-profile/'+request.data;
    return service.delete(ENDPOINT);   
};

